import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../../Component/loader/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  if (req.method != 'GET') {
    // Mostrar el loading
    loaderService.showLoader();
  }

  return next(req).pipe(
    finalize(() => {
      if (req.method != 'GET') {
        // Ocultar el loading
        loaderService.hideLoader();
      }
    }),
  );
};
